/* hs-eslint ignored failing-rules */

/* eslint-disable react/no-unused-prop-types */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import TimezoneTypes from '../constants/TimezoneTypes';
import RelativeDurationFormats from '../constants/RelativeDurationFormats';
import formatDuration from '../utils/formatRelativeDuration';

const getRelativeDuration = (from, to, options) => formatDuration(I18n.moment.duration(Math.abs(to.diff(from))), options);

export default class FormattedDuration extends Component {
  render() {
    const {
      includeAffix,
      type,
      from,
      to,
      format,
      combined
    } = this.props;
    const nowMoment = I18n.moment[type]();
    let duration;

    if (!to && !from) {
      duration = '';
    } else if (!to) {
      const fromValue = I18n.moment[type](from);
      duration = format ? getRelativeDuration(fromValue, nowMoment, {
        format,
        combined
      }) : fromValue.toNow(!includeAffix);
    } else if (!from) {
      const toValue = I18n.moment[type](to);
      duration = format ? getRelativeDuration(nowMoment, toValue, {
        format,
        combined
      }) : toValue.fromNow(!includeAffix);
    } else {
      const fromValue = I18n.moment[type](from);
      const toValue = I18n.moment[type](to);
      duration = format ? getRelativeDuration(fromValue, toValue, {
        format,
        combined
      }) : toValue.from(fromValue, !includeAffix);
    }

    return /*#__PURE__*/_jsx("span", {
      children: duration
    });
  }

}
FormattedDuration.displayName = 'FormattedDuration';
FormattedDuration.propTypes = {
  includeAffix: PropTypes.bool,
  type: PropTypes.oneOf([TimezoneTypes.PORTAL, TimezoneTypes.USER, TimezoneTypes.UTC]),
  format: PropTypes.oneOf(Object.keys(RelativeDurationFormats).map(format => RelativeDurationFormats[format])),
  from: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array]),
  to: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array]),
  toFromValidator: (props, propName, componentName) => {
    if (!props.from && !props.to) {
      console.warn(`${componentName} should have either a "to" or a "from" prop`, componentName);
    }
  },
  combined: PropTypes.bool
};
FormattedDuration.defaultProps = {
  type: TimezoneTypes.PORTAL,
  includeAffix: false,
  combined: false
};